import { useState, useEffect } from "react";
import Cookies from "universal-cookie";
import PropTypes from 'prop-types';
import { getDispensaActivos, ValidarDispensador } from "../../services/public/dispensador";
import Toasts from "../toast";
import Modal from "../modal";
import { useNavigate } from "react-router-dom";

function VincularModal({ show, handleshow, handleparams }) {
    const [codigovinc, setCodigoVinc] = useState("");
    const [dispensador, setDispensador] = useState([]);
    const [dispensaid, setDispensa] = useState(0);
    const [showToast, setShowToast] = useState(false);
    const [opciones, setOpciones] = useState([]);
    const [habilita, setHabilita] = useState(false);
    const navigate = useNavigate();
  /**
   * 
   */ 
  const handleAceptar = async() => {
    setHabilita(true);
    setShowToast(false);
    const response = await ValidarDispensador(dispensaid,codigovinc);
    if (response) {
        if (response.status === 200) {
           const cookies = new Cookies();
             cookies.set('ApkI',response.data.data[0].ClientAPKey, { path: "/" ,maxAge: 1000000});
             cookies.set('ApkV',response.data.data[0].CodigoVinc, { path: "/", maxAge: 1000000 });
           //  cookies.set('Ctrar',response.data.data[0].AreaId, { path: "/", maxAge: 1000000 });
             cookies.set('Ctrdisp',response.data.data[0].DispensaId, { path: "/",maxAge: 1000000 });
             cookies.set('Ctrndisp',response.data.data[0].NombreDisp, { path: "/",maxAge: 1000000 });
             cookies.set('Simpr',response.data.data[0].Imprime, { path: "/",maxAge: 1000000 });
             cookies.set('Impr',response.data.data[0].Impresora, { path: "/",maxAge: 1000000 });
             cookies.set('Puerto',response.data.data[0].Puerto, { path: "/",maxAge: 1000000 });
             handleshow(false);  
             handleparams();
        }
        else {
            const Mensaje = response.message;
            const opc = { type: "Danger", message: Mensaje, active: true };
            setOpciones(opc);
            setShowToast(true);
        }
    }
    setHabilita(false);
  };
/**
 * 
 */
  const handleCancel = async () => {
    handleshow(false);
    navigate('/');
  };
 /**
  * 
  */ 
  const handleDispensa = async()=>{
    const response = await getDispensaActivos();
    if (response) {
        if (response.status === 200) {
            setDispensador(response.data.data|| []);    
        }
        else {
            const Mensaje = response.message;
            const opc = { type: "Danger", message: Mensaje, active: true };
            setOpciones(opc);
            setShowToast(true);
        }
    }  
  }

  useEffect(() => {
    if (show) {
      handleDispensa()
    }
  }, [show]);
 
  return (
    <>
       <Modal isOpen={show} onClose={()=>handleshow(false)} title={'Vincular Dispositivo'}>
           <div className="flex lg:w-[24rem]">
              <form noValidate className="w-full">
                 <div className="w-full">
                    <label>Dispensador</label>
                    <select id="dispensador" name="dispensador" className="" value={dispensaid || ""} onChange={(e) => setDispensa(e.target.value)} label="Dispensador">
                       <option value="" disabled>
                          Seleccionar un Dispensador...
                       </option>
                       {dispensador.map((item) => {
                         return (
                             <option key={item.DispensaId} value={item.DispensaId}>
                                {item.NombreDisp} ( Area &#10148; {item.NombreArea})
                             </option>
                           );
                        })}
                     </select>
                  </div>

            <div className="mt-4">
               <label>Código de Vinculación</label>
               <input type="text" value={codigovinc} placeholder="Código de 8 caracteres" autoComplete="off" onChange={(e) => setCodigoVinc(e.target.value)}></input>
               <div className="flex w-full gap-4 mt-6 justify-end">
                 <button name="Aceptar" className="btnprimary" onClick={handleAceptar} disabled={habilita} type="button">Aceptar</button>
                 <button name="Cancelar" className="" onClick={handleCancel} disabled={habilita} type="button">Cancelar</button>
               </div>
            </div>
         </form>
         </div>
     </Modal>

     {showToast && (
               <Toasts
                 type={opciones.type}
                 message={opciones.message}
                 active={opciones.active}
               ></Toasts>
             )}
    
    </>
  );
}
VincularModal.propTypes = {
  show: PropTypes.bool.isRequired,
  handleshow: PropTypes.func.isRequired,
  handleparams: PropTypes.func.isRequired,
};

export default VincularModal;
